import { useState } from 'react';
import DOMPurify from 'dompurify';

const accordionData = {
    title: "Лицензированные компоненты",
    headers: ["Компонент", "Функциональность"],
    rows: [
        {
            component: "<span class='font-bold'>Компонент -</span> Единый агент мониторинга <span class='font-bold'>«ЕА»</span>",
            functionality: "Единый агент мониторинга – агент, устанавливаемый на виртуальный хост – сервер приложений, web сервер, балансировщик и другие компоненты системы. Осуществляет мониторинг инфраструктуры, трэйсинг кода, захват ключевых метрик и передает их на сервер КЛЮЧ АСТРОМ"
        },
        {
            component: "<span class='font-bold'>Компонент </span>Внешние источники данных <span class='font-bold'>«ВИД»</span>",
            functionality: "Данный Внешние источники данных компонент осуществляет сбор и передачу метрик через API от внешних систем и устройств в интерфейс Ключ-АСТРОМ"
        },
        {
            component: "<span class='font-bold'>Компонент </span><span class='font-light'>Цифрового опыт</span>а <span class='font-bold'>«ЦО»*</span>",
            functionality: "Данный компонент осуществляет мониторинг цифрового опыта пользователей ИТ сервиса .Он позволяет отслеживать до 100 процентов сессий пользователей как через веб клиент, так и через толстый клиент и мобильное приложение с углублением до серверной части запросов. Все сессии привязываются к уникальным пользователям по их логинам либо идентификаторам . Также, компонент ЦО позволяет воспроизводить сессии пользователей, осуществлять синтетические тесты"
        }
    ]
};

const PriceAccordion = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center">
            <div className="w-full xl:w-[871px] px-5 py-20 rounded-[20px] flex-col justify-start items-start inline-flex">
                
                {/* accordion header */}
                <div 
                    className="pl-[27px] pr-5 pt-3.5 pb-4 bg-[#d8b595] rounded-tl-[10px] rounded-tr-[10px] justify-between items-center xl:items-start w-full inline-flex cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div className="text-center text-white text-xl xl:text-2xl font-bold font-['Open Sans']">
                        {accordionData.title}
                    </div>
                    <div className={`mt-[10px] xl:mt-[0px] w-[33px] h-[33px] transition-transform duration-300 ${isOpen ? '' : 'rotate-180'}`}>
                        <div className="w-full xl:w-[33px] h-auto xl:h-[33px] bg-white rounded-full flex items-center justify-center">
                        <svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.5" cy="17.084" r="16.5" fill="white"/>
                            <path d="M16.2929 22.8751C16.6834 23.2656 17.3166 23.2656 17.7071 22.8751L24.0711 16.5111C24.4616 16.1206 24.4616 15.4874 24.0711 15.0969C23.6805 14.7064 23.0474 14.7064 22.6569 15.0969L17 20.7538L11.3431 15.0969C10.9526 14.7064 10.3195 14.7064 9.92893 15.0969C9.53841 15.4874 9.53841 16.1206 9.92893 16.5111L16.2929 22.8751ZM16 12.168L16 22.168L18 22.168L18 12.168L16 12.168Z" fill="#FFB805"/>
                        </svg>

                        </div>
                    </div>
                </div>

                {/* accordion content */}
                {isOpen && (
                    <div className="flex-col justify-start items-start gap-2.5 flex w-full bg-[#EBEBEB] p-[20px] rounded-bl-[10px] rounded-br-[10px]">
                        {/* Table Headers - Mobile optimized */}
                        <div className="w-full px-4 md:px-[27px] py-3.5 bg-white rounded-[10px] grid grid-cols-1 md:grid-cols-2 hidden md:flex md:justify-start md:items-start gap-4 md:gap-[136px] ">
                            {accordionData.headers.map((header, index) => (
                                <div key={index} className="text-[#544a28] text-sm md:text-xl font-bold font-['Open Sans'] whitespace-nowrap md:w-[200px]">
                                    {header}
                                </div>
                            ))}
                        </div>

                        {/* Table Rows - Mobile optimized */}
                        {accordionData.rows.map((row, index) => (
                            <div key={index} className="w-full px-4 md:px-[27px] py-3.5 bg-white rounded-[10px] grid grid-cols-1 md:grid-cols-2 md:flex md:justify-start md:items-start gap-4 md:gap-[136px]">
                                <div className="text-[#544a28] text-sm md:text-xl font-bold font-['Open Sans'] md:hidden">
                                    {accordionData.headers[0]}
                                </div>

                                <div 
                                    className="w-full md:w-[200px] md:text-center text-[#544a28] text-sm md:text-base break-words"
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.component) }}
                                />
                                <div className="text-[#544a28] text-sm md:text-xl font-bold font-['Open Sans'] md:hidden">
                                    {accordionData.headers[1]}
                                </div>
                                <div 
                                    className="flex-1 text-[#544a28] text-sm md:text-base font-normal whitespace-normal"
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.functionality) }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PriceAccordion;